<template>
	<div class="page-dashboard">
		<div class="container-fluid">
			<!-- Table Menu -->
			<div class="table-menu flex-center">
				<div>
					<h2 class="text-primary mb-3">
						{{ $t(title) }}
					</h2>
					<p class="text-darker mb-4">
						{{ $t('Adjust your input device size and position to create a presentation, side by side or other custom layout') }}
					</p>
				</div>
				<div class="d-flex flex-row-reverse">
					<input class="form-control"
						:placeholder="$t('Search')"
						@input="onKeywordChange"
						v-model="keyword" type="text">
				</div>
			</div>

			<!-- Recent Compositions -->
			<div class="p-5 text-center" v-if="isFetching">
				<div class="is-loading large"></div>
			</div>
			<div class="mb-extreme">
				<div>
					<div>
						<div class="flex-center mb-3" v-if="mode !== 'archived' && !isFetching">
							<router-link v-if="!isFetching && filteredItems.length !== 0" to="/compositions/show/recent" class="text-white">
								{{ $t('Recents Compositions') }}
							</router-link>
							<router-link
							v-if="mode === 'normal' && totalItems > 8 && !isFetching"
								to="/compositions/show/recent"
								class="text-white td-u ml-a">
								{{ $t('Show All') }}
							</router-link>
							<router-link
								to="/compositions"
								class="text-white td-u ml-a"
								v-if="mode !== 'normal'" >
								{{ $t('Back') }}
							</router-link>
						</div>
							<div v-if="filteredItems.length !== 0">
								<div class="row row-cols-4 mb-extreme" v-if="mode !== 'archived'">
									<div v-for="item in filteredItems" :key="item.id">
										<div>
										<!-- <div  @contextmenu.prevent="$refs.ctx.open($event, items)"> -->
										<div class="col mb-4">
											<div class="card card-item">
												<div class="card-body">
													<div class="card-top d-flex justify-content-between">
														<div class="text-lg pointer" @click="$router.push(`/compositions/editor/${item.id}`)">
															{{ item.name }}
														</div>
														<md-menu
															class="h-fc"
															md-size="small"
															md-direction="bottom-end"
															md-align-trigger>
															<md-button
																class="btn-fluid"
																:md-ripple="false"
																md-menu-trigger>
																<i class="material-icons md-18 p-0 h-fc">more_vert</i>
															</md-button>
															<md-menu-content class="minw-200">
																<md-menu-item @click="open(item.id)">{{ $t('Open') }}</md-menu-item>
																<md-menu-item
																	@click="openModalDuplicate(item)">
																	{{ $t('Duplicate') }}
																</md-menu-item>
																<md-menu-item @click="view(item.id)">{{ $t('View') }}</md-menu-item>
																<md-menu-item v-if="user && user.id === item.user_id || isSuperAdmin" @click="confirmRename(item)">{{ $t('Rename') }}</md-menu-item>
																<md-menu-item @click="copyUrl(item)">{{ $t('Copy URL') }}</md-menu-item>
																<md-menu-item @click="archive(item)">{{ $t('Archive') }}</md-menu-item>
																<md-menu-item
																	@click="deleteItem(item)">
																	{{ $t('Delete') }}
																</md-menu-item>
															</md-menu-content>
														</md-menu>
													</div>
													<div class="card-divider"></div>
													<div class="card-info d-flex justify-content-end">
														<span>{{ item.created_at }}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<pagination
								:current-page="page"
								:total-pages="lastPage"
								@select="onPageSelected(false, ...arguments)"
								v-if="mode !== 'normal' && mode !== 'archived'">
							</pagination>
						</div>
						<div class="text-center mb-6" v-if="filteredItems.length === 0 && mode !== 'archived'">
							<label v-if="!isFetching">{{ $t('No Composition available') }}</label>
						</div>
						<!-- archived -->
						<div
							class="mb-5"
							v-if="mode === 'normal' || mode === 'archived'  && !isFetchingArchived">
							<div class="d-flex justify-content-between mb-3">
								<router-link v-if="archivedItems.length > 0" to="/compositions/show/archived" class="text-white">
									{{ $t('Archived Compositions') }}
								</router-link>
								<router-link to="/compositions/show/archived" class="text-white td-u ml-a" v-if="mode === 'normal' && totalArchivedItems > 8">
									{{ $t('Show All') }}
								</router-link>
								<span @click="backToAll" class="text-white td-u ml-a" v-else-if="mode !== 'normal'">
									{{ $t('Back') }}
								</span>
							</div>
							<div class="mt-3" v-if="archivedItems.length > 0">
								<div class="row row-cols-4">
									<div v-for="item in archivedItems" :key="item.id" >
										<div @contextmenu.prevent="$refs.ctx.open($event, items)" >
										<div class="col mb-4" v-if="item.is_archived">
											<div class="card card-item">
												<div class="card-body">
													<div class="card-top d-flex justify-content-between">
														<div class="text-lg pointer" @click="$router.push(`/compositions/editor/${item.id}`)">
															{{ item.name }}
														</div>
														<md-menu
															class="h-fc"
															md-size="small"
															md-direction="bottom-end"
															md-align-trigger>
															<md-button
																class="btn-fluid"
																:md-ripple="false"
																md-menu-trigger>
																<i class="material-icons md-18 p-0 h-fc">more_vert</i>
															</md-button>
															<md-menu-content class="minw-200">
																<md-menu-item @click="open(item.id)">{{ $t('Open') }}</md-menu-item>
																<md-menu-item
																	@click="openModalDuplicate(item)">
																	{{ $t('Duplicate') }}
																</md-menu-item>
																<md-menu-item @click="view(item.id)">{{ $t('View') }}</md-menu-item>
																<md-menu-item v-if="user && user.id === item.user_id || isSuperAdmin" @click="confirmRename(item)">{{ $t('Rename') }}</md-menu-item>
																<md-menu-item @click="copyUrl(item)">{{ $t('Copy URL') }}</md-menu-item>
																<md-menu-item @click="archive(item)">{{ $t('UnArchive') }}</md-menu-item>
																<md-menu-item
																	@click="deleteItem(item)">
																	{{ $t('Delete') }}
																</md-menu-item>
															</md-menu-content>
														</md-menu>
													</div>
													<div class="card-divider"></div>
													<div class="card-info d-flex justify-content-end">
														<span>{{ item.created_at }}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
									</div>
								</div>
							</div>
							<div class="text-center mt-6 hidden" v-else>
								{{ $t('No Archive Composition available') }}
							</div>
							<pagination
								:current-page="archivedPage"
								:total-pages="lastArchivedPage"
								@select="onArchivedPageSelected(false, ...arguments)"
								v-if="mode !== 'normal'">
							</pagination>
						</div>
					</div>
					<!-- Table Pagination -->
				</div>
				<!-- <ContextMenu
				ref="ctx" @ctx-open="onCtxOpen" @ctx-cancel="resetCtxLocals" @ctx-close="onCtxClose">
					<li class="ctx-item"> {{  $t('Open')  }} </li>
					<li class="ctx-item"> {{  $t('Duplicate')  }} </li>
					<hr>
					<li class="ctx-item"> {{ $t('View') }} </li>
					<li class="ctx-item"> {{ $t('Copy URL') }} </li>
					<hr>
					<li class="ctx-item"> {{ $t('Archive') }} </li>
					<li class="ctx-item"> {{ $t('Delete') }} </li>
				</ContextMenu> -->
			</div>
		</div>
		<!-- Delete Confirmation -->
		<modal
			size="small"
			@close="isConfirmRemoveVisible = false"
			v-if="isConfirmRemoveVisible && selected">
			<template slot="header">
				{{ $t('Remove Composition') }}
			</template>
			<template slot="body">
				{{ $t('Are you sure want to delete') }} {{ showModalName(selected && selected.name ? selected.name : '') }}?
			</template>
			<template slot="footer">
				<button
					class="btn btn-primary"
					:class="{ 'is-loading': isRemoving }"
					@click="removeItem(selected)">
					{{ $t('Remove') }}
				</button>
				<button
					class="btn btn-default"
					@click="isConfirmRemoveVisible = false">
					{{ $t('Cancel') }}
				</button>
			</template>
		</modal>
		<!-- Archive Confirmation -->
		<modal
			@close="isConfirmArchiveVisible = false"
			v-if="isConfirmArchiveVisible && selected">
			<template slot="header">
				<h3>{{ $t('Remove User') }}</h3>
			</template>
			<template slot="body">
				{{ $t('Are you sure want to delete') }} {{ selected && selected.name ? selected.name : '' }}?
			</template>
			<template slot="footer">
				<button
					class="btn btn-default"
					@click="isConfirmArchiveVisible = false">
					{{ $t('Cancel') }}
				</button>
				<button
					class="btn btn-danger"
					:class="{ 'is-loading': isRemoving }"
					@click="removeItem(selected)">
					{{ $t('Remove') }}
				</button>
			</template>
		</modal>
		<!-- Duplicate Confirmation -->
		<modal
			size="small"
			@close="isConfirmDuplicateVisible = false"
			v-if="isConfirmDuplicateVisible && selected">
			<template slot="header">
				{{ $t('Duplicate Composition') }}
			</template>
			<template slot="body">
				{{ $t('Are you sure want to duplicate') }} {{ showModalName(selected && selected.name ? selected.name : '') }}?
			</template>
			<template slot="footer">
				<button
					class="btn btn-primary"
					:class="{ 'is-loading': isDuplicating }"
					@click="duplicate(selected)">
					{{ $t('Duplicate') }}
				</button>
				<button
					class="btn btn-default"
					@click="isConfirmDuplicateVisible = false">
					{{ $t('Cancel') }}
				</button>
			</template>
		</modal>
		<!-- Rename Rundown -->
		<modal
			size="small"
			@close="isRenameVisible = false"
			v-if="isRenameVisible"
			>
			<template slot="header">
				{{ $t('Rename Composition') }}
			</template>
			<template slot="body">
				<div class="form-group mb-3">
					<input
						type="text"
						class="form-control"
						:placeholder="$t('Composition Name')"
						v-model="compositionName"
					/>
				</div>
			</template>
			<template slot="footer">
				<button
					type="button"
					class="btn btn-primary"
					:class="{ 'is-loading': isSavingComposition }"
					@click="updateName(selected)">
					{{ $t('Save') }}
				</button>
				<button
					type="button"
					class="btn btn-default"
					@click="isRenameVisible = false">
					{{ $t('Cancel') }}
				</button>
			</template>
		</modal>
	</div>
</template>

<script>
// import ContextMenu from 'vue-context-menu';
import { mapGetters } from 'vuex';
import compositionsApi from '@/api/compositions';
import {
	getAxiosErrorMessage,
	delay,
	elpisisString,
	duplicateVar,
} from '@/lib/helper';
import Modal from '@/components/Modal.vue';
import Pagination from '@/components/Pagination.vue';

export default {
	name: 'Composition',
	components: {
		// ContextMenu,
		Modal,
		Pagination,
	},
	data() {
		return {
			title: 'Composition',
			viewMenu: false,
			top: '0px',
			left: '0px',
			page: 1,
			limit: 8,
			orderBy: 'created_at',
			sortBy: 'desc',
			keyword: '',
			isAll: false,
			items: [],
			selected: null,
			// totalPages: 2,
			totalItems: 0,
			lastPage: 1,
			isFormVisible: false,
			isConfirmRemoveVisible: false,
			isConfirmArchiveVisible: false,
			isRemoving: false,
			isDuplicating: false,
			mode: 'normal',
			isFetching: false,
			isConfirmDuplicateVisible: false,
			// archived
			archivedPage: 1,
			archivedLimit: 8,
			archivedOrderBy: 'created_at',
			archivedSortBy: 'desc',
			totalArchivedItems: 0,
			lastArchivedPage: 1,
			archivedIsAll: false,
			isFetchingArchived: false,
			archivedItems: [],
			compositionName: '',
			isRenameVisible: false,
			isSavingComposition: false,
		};
	},
	watch: {
		'$route.params.status': {
			handler(status) {
				this.mode = status || 'normal';
				this.fetch(1);
			},
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		fetchParams() {
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
				user_id: this.user.id,
			};
			const keyword = this.keyword.trim();
			if (keyword !== '') {
				params.keyword = keyword;
			}
			return params;
		},
		filteredItems() {
			const filtered = this.items.filter(item => !item.is_archived);
			return filtered;
		},
		totalPages() {
			const total = Math.ceil(this.totalItems / this.limit);
			return total;
		},
	},
	methods: {
		fetch(reset = false, page) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			if (page) {
				this.page = page;
			}
			const recent = this.$route.params.status === 'recent';
			const params = duplicateVar(this.fetchParams);
			if (recent) {
				params.is_archived = 0;
			} else {
				params.is_archived = null;
			}

			const callback = (response) => {
				const items = response.data;
				if (items.length < this.limit) {
					this.isAll = true;
				}
				this.items = items;
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
				this.isFetching = false;
			};
			params.is_archived = 0;
			compositionsApi.getList(params, callback, errorCallback);
		},
		fetchArchived(reset = false, archivedPage) {
			this.isFetchingArchived = true;
			if (reset) {
				this.archivedPage = 1;
				this.archivedItems = [];
			}
			if (archivedPage) this.archivedPage = archivedPage;
			const params = {
				page: this.archivedPage,
				limit: this.archivedLimit,
				order_by: this.archivedOrderBy,
				sort_by: this.archivedSortBy,
				user_id: this.user.id,
				is_archived: 1,
			};
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.archivedLimit) this.archivedIsAll = true;
				this.totalArchivedItems = response.total;
				this.lastArchivedPage = response.lastPage;
				this.insertItems(items);
				this.isFetchingArchived = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
				this.isFetchingArchived = false;
			};
			compositionsApi.getList(params, callback, errorCallback);
		},
		onKeywordChange() {
			delay(() => {
				this.fetch(true);
				this.fetchArchived(true);
			}, 500);
		},
		onPageSelected(isArchived, page) {
			this.fetch(true, page);
		},
		onArchivedPageSelected(isArchived, archivedPage) {
			this.fetchArchived(true, archivedPage);
		},
		open(id) {
			this.$router.push(`/compositions/editor/${id}`).catch(() => {});
		},
		openModalDuplicate(item) {
			this.isConfirmDuplicateVisible = true;
			this.selected = item;
		},
		duplicate(item) {
			this.create(item);
			this.isConfirmDuplicateVisible = false;
		},
		view(id) {
			const routeData = this.$router.resolve({ path: `/compositions/view/${id}` });
			window.open(routeData.href, '_blank');
			// this.$router.push(`/compositions/view/${id}`);
		},
		copyUrl(item) {
			const tempInput = document.createElement('input');
			tempInput.value = `${process.env.VUE_APP_URL}/compositions/view/${item.id}`;
			document.body.appendChild(tempInput);
			tempInput.select();
			document.execCommand('copy');
			document.body.removeChild(tempInput);
			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Composition',
				text: 'succesfully copy url',
			});
		},
		archive(item) {
			const params = {
				is_archived: item.is_archived ? 0 : 1,
			};
			const callback = (response) => {
				const composition = response.data;
				const message = response.message;
				if (!item.is_archived) {
					const index = this.items.findIndex(({ id }) => id === item.id);
					if (index !== -1) {
						this.items.splice(index, 1);
						this.archivedItems.push(composition);
					}
				} else {
					const index = this.archivedItems.findIndex(({ id }) => id === item.id);
					if (index !== -1) {
						this.archivedItems.splice(index, 1);
						this.items.push(composition);
					}
				}
				this.isArchiving = false;
				this.isConfirmArchiveVisible = false;
				this.isConfirmUnarchiveVisible = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Composition',
					text: message,
				});
			};
			const errorCallback = (e) => {
				const message = e;
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Composition',
					text: message,
				});
			};
			compositionsApi.update(item.id, params, callback, errorCallback);
		},
		deleteItem(item) {
			this.selected = item;
			this.isConfirmRemoveVisible = true;
		},
		removeItem(item) {
			this.isRemoving = true;
			const callback = (response) => {
				const message = response.message;
				if (item.is_archived) {
					const index = this.archivedItems.findIndex(({ id }) => id === item.id);
					if (index !== -1) {
						this.archivedItems.splice(index, 1);
					}
				} else {
					const index = this.items.findIndex(({ id }) => id === item.id);
					if (index !== -1) {
						this.items.splice(index, 1);
					}
				}
				this.isRemoving = false;
				this.isConfirmRemoveVisible = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Remove Display',
					text: message,
				});
			};
			const errorCallback = (e) => {
				this.isRemoving = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Remove Display',
					text: message,
				});
			};
			compositionsApi.delete(item.id, callback, errorCallback);
		},
		create(item) {
			this.isDuplicating = true;
			const name = `Duplicate of ${item.name}`;
			const params = {
				name,
				file_path: item.file_path,
				is_archived: item.is_archived,
				layout_id: item.layout_id,
			};
			const callback = (response) => {
				const duplicatedItem = response.data;
				this.items.push(duplicatedItem);
				const message = response.message;
				this.isDuplicating = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Duplicate Display',
					text: message,
				});
			};
			const errorCallback = (e) => {
				this.isDuplicating = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Duplicate Display',
					text: message,
				});
			};
			compositionsApi.create(params, callback, errorCallback);
		},
		updateName(item) {
			this.isSavingComposition = true;
			const params = {
				name: this.compositionName,
			};
			const callback = (response) => {
				const message = response.message;
				const composition = response.data;
				if (composition.is_archived) {
					const indexArchived = this.archivedItems.findIndex(({ id }) => id === composition.id);
					if (indexArchived !== -1) {
						this.$set(this.archivedItems, indexArchived, composition);
					}
				} else {
					const index = this.items.findIndex(({ id }) => id === composition.id);
					if (index !== -1) {
						this.$set(this.items, index, composition);
					}
				}
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Update Composition',
					text: message,
				});
				this.isRenameVisible = false;
				this.isSavingComposition = false;
			};
			const errorCallback = (e) => {
				this.isDuplicating = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Update Composition',
					text: message,
				});
				this.isRenameVisible = false;
				this.isSavingComposition = false;
			};
			compositionsApi.update(item.id, params, callback, errorCallback);
		},
		insertItems(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				if (item.is_archived) {
					const index = items.findIndex(({ id }) => id === item.id);
					if (index === -1) {
						this.archivedItems.push(item);
					} else {
						this.$set(this.archivedItems, index, item);
					}
				} else {
					const index = items.findIndex(({ id }) => id === item.id);
					if (index === -1) {
						this.items.push(item);
					} else {
						this.$set(this.items, index, item);
					}
				}
				// }
			}
		},
		// eslint-disable-next-line no-unused-vars
		onCtxOpen(locals) {
		},

		// eslint-disable-next-line no-unused-vars
		onCtxClose(locals) {
		},

		resetCtxLocals() {
		},
		showModalName(str) {
			return elpisisString(str);
		},
		backToAll() {
			this.fetchArchived(true);
			this.$router.push('/compositions');
		},
		confirmRename(item) {
			this.compositionName = item.name;
			this.selected = item;
			this.isRenameVisible = true;
		},
	},
	created() {
		if (this.$route.params.status === 'archived') {
			this.mode = 'archived';
		} else if (this.$route.params.status === 'recent') {
			this.mode = 'recent';
		} else {
			this.mode = 'normal';
		}
		this.fetch();
		this.fetchArchived(true);
	},
};
</script>
